<template>
  <div class="right-chart-2">
    <dv-scroll-board :config="list" class="lc3-chart"/>
  </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LayoutRight2',
    data() {
        return {
            list: {
            },
            mapChart: null,
            mapOtion: null,
        }
    },
    mounted() {
        this.loadList()
    },
    methods: {
        loadList() {
            var that = this;
            axios.get(this.$store.state.config.host + "/v1/block/" + window.encodeURI('数据大屏_直播数据') + '/?cid=4000').then(response => {
                var list = {
                    header: ['直播题目', '人数'],
                    rowNum: 4,
                    columnWidth: [50, 340, 70],
                    index: true,
                    align: 'left',
                    data: []
                };
                Object.values(response.data.data).forEach(element => {
                    list.data.push([
                        element.title,
                        element.title1
                    ])
                });
                that.list = list
            })
        },
    }
}
</script>

<style lang="less">
.right-chart-2 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;
  }

</style>


